<script>
import { arclinks } from "./arclinks.js";
import * as world from './World_No_Borders.json';
import { geoEqualEarth, geoPath} from "d3-geo";
import { csv as d3csv, json as d3json } from "d3-fetch";
import { zoom, zoomTransform, zoomIdentity } from "d3-zoom";
import { select as d3select } from "d3-selection";
import { forceSimulation, forceManyBody, forceCenter,forceLink} from "d3-force";
import { drag } from "d3-drag"
import { scaleSqrt} from "d3-scale";
import { extent } from "d3-array";
import { Col, Row, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap';
import AutoComplete from "simple-svelte-autocomplete";
import { onMount} from "svelte";

import {countryColors, countryDetails } from "./data.js";
var bootstrapStyle = "https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css"

import { _ , init, addMessages, number} from "svelte-i18n";

// using parameter 'language' in url for detecting language, this can be used for test purposes ----
var url = new URL(window.location.href)
var language = url.searchParams.get("language");

var dir = 'ltr';
let years = ["1998-2007","2008-2017"];
let yearsAr = ["2007-1998","2017-2008"];

$:{
    init({
        fallbackLocale: 'en',
        initialLocale: language
    });
    if (language == 'ar') {
        dir = "rtl";
        d3select('html').attr('dir','rtl') 
        bootstrapStyle = "https://cdn.rtlcss.com/bootstrap/v4.5.3/css/bootstrap.min.css";
    }
    loadLanguageFiles(language);
} 

var patArray =[], pubArray =[], countryArray =[], hotspotArray =[], dataLoaded = false;

function loadLanguageFiles(language){
	Promise.all([
		d3json('./lang/text/'+ language +'.json'),
		d3csv('./lang/countries/'+ language +'.csv'),
		d3csv('./lang/pat/'+ language +'.csv'),
		d3csv('./lang/pub/'+ language +'.csv'),
        d3csv('./lang/hotspots/'+ language +'.csv')
	]).then((results) => {		
		var text = results[0]
		addMessages(language, text)
        countryArray = results[1];
        patArray = results[2];
        pubArray = results[3];
        hotspotArray = results[4];
        dataLoaded = true;
	})
}
function countryNameFromId(id){
    if (id == "" || !dataLoaded) return "";
    else return countryDetails.filter((d)=> +d.id == +id)[0].name;
}
function countryTranslationFromId(id, countryArray){
    if (id == "" || !dataLoaded) return "";
    else return countryArray.filter((d)=> +d.id == +id)[0].name;
}
function cityTranslationFromId(id, hotspotArray){
    if (id == "" || !dataLoaded) return "";
    return hotspotArray.filter((d)=> +d.id == +id)[0].name;
}

let isOpen = false;

// start values for map
var selectedField = 0, selectedCountry = "", selectedCity = {id:0}, yearValue = "2008-2017", percentValue = 1, countryCitiesArray = [], sort="pat";
var cities =[],flows=[];
let transform = zoomIdentity, w;
let zoomMap, bordersData, projection;
let noFlowsSelectedCity = false;
$: height = (w < 576)? w * .7 : w/2;
$: projectionScale =(w < 576)? w/4.5:w/4.8;


/*$: if (dataLoaded) {
    console.log('pat',patArray,'pub',pubArray, 'countries', countryArray);
    console.log('dataloaded')
}*/

// start values for network
var selectedField1 = 0, selectedCountry1 = "", selectedCity1 = {id:0}, yearValue1 = "2008-2017", percentValue1 = 1, countryCitiesArray1 = [], sort1="pat";
var cities1 =[],flows1=[], netWidth = 700, legendWidth1 = 200;
$: netHeight = (netWidth < 567)? netWidth * 1.2: netWidth * 0.8;
let simulation;
let promiseNet;
let zoomNet,transformNet = zoomIdentity;
let sqrtScale = scaleSqrt().range([3,14]);
let noFlowsSelectedCity1 = false;

// for map and network
var mouseCity = {'id':0};
let percents = [1,5,10];
let mousePosition = {x:0,y:0}, mouseSort;
let tooltipWidth = 150;
const sortObject = {"pat":"techs35","pub":"fields"}
var draggingCircle = false;

//// -----
let promiseMap;
$: {
    promiseMap = [
        d3csv('./data/'+sortObject[sort]+'/nodes_'+sort+'_'+ yearValue +'_'+ selectedField +'.csv'),
        d3csv('./data/'+sortObject[sort]+'/links_'+sort+'_'+ yearValue +'_'+ selectedField +'.csv')
    ]
    loadDataMap();
}
function loadDataMap(){
    Promise.all(promiseMap).then(([citiesData,flowsData]) => {
        cities=[],flows=[];
        cities = citiesData, flows = addNodeData(citiesData,flowsData)
        // if a city is selected it's necessary to change the city object because
        // it might have a different istop value in the new file
        if (selectedCity.id > 0){
            let sel = cities.filter((city) => { return city.id == selectedCity.id })
            if ( sel.length < 1 ) noFlowsSelectedCity =true;
            else  {
                selectedCity = sel[0];
                noFlowsSelectedCity = (selectedCity.istop <= percentValue)?false:true;
            }
        }
        d3select('.map svg').call(zoomMap)
    }) 
}

$: { 
    if (selectedCountry != "") countryCitiesArray = cities.filter((city) => city.ctry_label == countryNameFromId(selectedCountry))
    else countryCitiesArray = [];
}
$:{
    /// projection ----- 
    projection = geoEqualEarth()
        .rotate([-10,0])
        .scale(projectionScale)
        .translate([w / 2 -20 , height / 2 + 30]);

    const path = geoPath().projection(projection);
    bordersData = path(world.features[0]);

}
$:{
    if (selectedCity.id > 0) {
        selectedCountry = "";
    }
}
$:{
    if (selectedCity1.id > 0){
        selectedCountry1 = ""; 
        updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id, false);
    }
}
$: {
    promiseNet = [
        d3csv('./data/'+sortObject[sort1]+'/nodes_'+sort1+'_'+ yearValue1 +'_'+ selectedField1 +'.csv'),
        d3csv('./data/'+sortObject[sort1]+'/links_'+sort1+'_'+ yearValue1 +'_'+ selectedField1 +'.csv')
    ]
    loadDataNet();
}
function loadDataNet(){
    if (simulation!= undefined) simulation.stop();
    Promise.all(promiseNet).then(([citiesData,flowsData]) => { 
        cities1 =[],flows1=[];
        cities1 = citiesData; 
        sqrtScale.domain(extent(cities1, (d) => { return Number(d[sort1+"Q"])}))

        flows1 = addNodeData(citiesData,flowsData)

        // if a city is selected it's necessary to change the city object because
        // it might have a different istop value in the new file
        if (selectedCity1.id > 0){
            let sel = cities1.filter((city) => { return city.id == selectedCity1.id })
            if ( sel.length < 1 ) noFlowsSelectedCity1 = true;
            else  {
                selectedCity1 = sel[0];
                noFlowsSelectedCity1 = (selectedCity1.istop <= percentValue1)?false:true;
            }
        }

        updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id,true);
        //console.log('netWidth',netWidth)
        // network simulation
        simulation = forceSimulation(cities1)
            .force("charge", forceManyBody())
            .force("center", forceCenter(netWidth / 2, netHeight / 2))
            .force("link", forceLink(flows1).id(d => d.id).strength(0.1).distance(8))
            .on("tick",simulationUpdate)

        d3select('.network svg g.nodes').call(dragging(simulation)).node();

        d3select('.network svg').call(zoomNet);

    })
}

$: if (selectedCountry1 != "") countryCitiesArray1 = cities1.filter((city) => city.ctry_label == countryNameFromId(selectedCountry1))

$: noFlowsSelectedCity = (selectedCity.istop <= percentValue)?false: true;

onMount(() => {
    /// zoom map -----
    zoomMap = zoom()
        .scaleExtent([1, 8])
        .translateExtent([[-100,-100],[1200,3000]])
        .on('zoom', zoomed);

    function zoomed(event){
        transform = zoomTransform(d3select('.map svg').node())
        d3select('.backgroundMap').attr('transform', event.transform);
        d3select('.map .flows').attr('transform', event.transform);
        d3select('.map .nodes').attr('transform', event.transform);
    }

    /// zoom network -----
    zoomNet = zoom()
        .scaleExtent([.5, 8])
        .translateExtent([[-1200,-3000],[1200,3000]])
        .on('zoom', zoomedNet);

    function zoomedNet(event){
        transformNet = event.transform;
        d3select('.network .flows').attr('transform', event.transform);
        d3select('.network .nodes').attr('transform', event.transform);
    }
})

var legendItemWidth = 185;

function legendItemPosition(legendWidth,i){
    if (legendWidth > 775){ // two levels
        var x = (dir == 'rtl')? legendWidth - 20 - legendItemWidth - Math.floor(i/2) * legendItemWidth:Math.floor(i/2) * legendItemWidth;
        if (i % 2 === 0) var y = 20;
        else y = 40;
    }
    else if(legendWidth > 400){
        var y = Math.floor(i/2) * 20 + 20;
        if (i % 2 === 0) var x = (dir == 'rtl')?legendWidth -legendItemWidth - 20: 0;
        else var x = (dir == 'rtl')? legendWidth - 20 - 2 * legendItemWidth : legendItemWidth;
    }
    else {
        var x = (dir == 'rtl')?legendWidth - 20: 0;
        var y = (i+1) * 20;
    }
    return  x +","+ y; 
}
function dragging (simulation) {

    function dragsubject(event) {
        const node = simulation.find(transformNet.invertX(event.x), transformNet.invertY(event.y));
        if (node) {
            node.x = transformNet.applyX(node.x);
            node.y = transformNet.applyY(node.y);
            return node;
        }
	}

    function dragstarted(event) {
        draggingCircle = true; 
        if (!event.active) simulation.alphaTarget(0.3).restart();
        event.subject.fx = transformNet.invertX(event.subject.x);
        event.subject.fy = transformNet.invertY(event.subject.y);
    }
  
    function dragged(event) {
        event.subject.fx = transformNet.invertX(event.x);
        event.subject.fy = transformNet.invertY(event.y);
    }
  
    function dragended(event) {
        mouseCity = {'id':0};
        if (!event.active) simulation.alphaTarget(0);
        event.subject.fx = transformNet.invertX(event.x); 
        event.subject.fy = transformNet.invertY(event.y); 
        draggingCircle = false;
    }
    return drag()
        .subject(dragsubject)
        .on("start", dragstarted)
        .on("drag", dragged)
        .on("end", dragended);
}

///------------
function simulationUpdate() { 
    simulation.tick();
    cities1 = [...cities1];
	flows1 = [...flows1];
};
function zoomIn(){
    d3select('.map svg').transition().call(zoomMap.scaleBy, 2)
}
function zoomOut(){
    d3select('.map svg').transition().call(zoomMap.scaleBy, 0.5)
}
function zoomInNet(){
    d3select('.network svg').transition().call(zoomNet.scaleBy, 2)
}
function zoomOutNet(){
    d3select('.network svg').transition().call(zoomNet.scaleBy, 0.5)
}

function addNodeData(nodes, links){
    links.forEach( function(link){
        let fromNode = nodes.find(obj => obj.id == link.from);
        let toNode = nodes.find(obj => obj.id == link.to);
        link._fromCoords = [fromNode.Lng,fromNode.Lat];
        link._toCoords = [toNode.Lng,toNode.Lat];
        link._fromCountry = fromNode.ctry_label;
        link._toCountry = toNode.ctry_label;
        link.source = link.from;
        link.target = link.to;
        link.value = link.weight;
        link._visible = (link.istop <= percentValue1)?true:false;
    })
    return links
}
function updateNetFlowsNodes(percentValue, selectedCountry, selectedCityId, first){

    if (selectedCountry == "" && selectedCityId == 0 ){
        //depending on istop
        if (!first){
            flows1.forEach((flow) => {
                flow._visible = (flow.istop <= percentValue) ? true:false;
                d3select('#link_'+flow.from+'-'+flow.to).classed('hide',!flow._visible);
            });
        }
    }
    // country selected ----
    else if (selectedCountry != ""){
        var countryName = countryNameFromId(selectedCountry)
        flows1.forEach((flow) => {
            if ( countryName == flow._fromCountry || countryName == flow._toCountry) flow._visible = (flow.istop <= percentValue) ? true:false;
            else flow._visible = false;
            d3select('#link_'+flow.from+'-'+flow.to).classed('hide',!flow._visible);
        })
    }         
    // city selected ----
    else {
        flows1.forEach((flow) => {
            if (selectedCityId == flow.from || selectedCityId == flow.to) flow._visible = (flow.istop <= percentValue) ? true:false;
            else flow._visible = false;
            d3select('#link_'+flow.from+'-'+flow.to).classed('hide',!flow._visible);
        })
    }

    // updating nodes
    cities1.forEach(function(city){
        let relatedFlows = flows1.filter(function(d) { return ((d.from == city.id || d.to == city.id) && d._visible )})
        city._visible = (relatedFlows.length > 0)? true:false;
        d3select('#node_'+city.id).classed('hide',!city._visible);
    })
    // check if there's at least one node visible
    if (cities1.filter((city)=>{ return (city._visible == true) }) == 0) noFlowsSelectedCity1 = true;// display message!
    else noFlowsSelectedCity1=false;

    if (!first){
        //simulation.restart();
        d3select('.network svg .nodes').call(dragging(simulation)).node();
        d3select('.network svg').call(zoomNet);
    }
}

function displayFlow(flow, percentValue, selectedCountry, selectedCityId){
    // no city or country selected ---- 
    if (selectedCountry== "" && selectedCityId == 0 ) flow._visible = (flow.istop <= percentValue) ? true:false;
    // country selected ----
    else if (selectedCountry != ""){
        var countryName = countryNameFromId(selectedCountry)       
        if (countryName == flow._fromCountry || countryName == flow._toCountry) flow._visible = (flow.istop <= percentValue) ? true:false;
        else flow._visible = false;
    }
    // city selected ----
    else {
        if (selectedCityId == flow.from || selectedCityId == flow.to) flow._visible = (flow.istop <= percentValue) ? true:false;
         else flow._visible = false;
    }
    return (flow._visible)?'block':'none';   
}
function displayCity(id,links){
    let relatedFlows = links.filter(function(d) { return ((d.from == id || d.to == id) && d._visible )})
    if (relatedFlows.length > 0) return "block";
    else return "none";
}
function handleMousemove(event) {
    mousePosition.x = event.pageX;
    mousePosition.y = event.pageY;
}
function xPositionTooltip(mousePosition){   
    tooltipWidth = (tooltipWidth == 0)?220:tooltipWidth;
    if (mousePosition.x + tooltipWidth < w) {
            d3select(".arrow_box").classed('arrow_right', false).classed('arrow_left', true)
            return (mousePosition.x + 20)
        }   
    else {
        d3select(".arrow_box").classed('arrow_right', true).classed('arrow_left', false)
        return (mousePosition.x - (tooltipWidth + 20) )
    }
}
</script>
<svelte:head>
    <link rel="stylesheet" href={ bootstrapStyle } >
    <link rel="stylesheet" href="./css/styles.css">
</svelte:head>
{#if (dataLoaded)}
<!--div class="container">
	<ul class="nav-breadcrumb">
		<li><a href="https://www.wipo.int/wipr/{language}/2019/">{ $_('note-b') }</a></li>
        <li class="active">{ $_('page-title') } </li>
	</ul>
</div-->
<div class="container-fluid">
	<div class="row content">
		<div class="col-12">
			<h1>{ $_('page-title') } </h1>
			<div>
                <p class="lead">{ $_('intro-text') }</p>
            </div>
		</div>
    </div>
    
    <div class="row cols--two">
        <div class="col-12 col-md-6">
            <figure>
                <a href="#map-layout"><img src="./images/map.png" alt="map with innovation hotspots and connections" class=""></a>
            </figure>
            <h3><a href="#map-layout">{ $_('map-title') }</a></h3>
            <p>{ $_('map-intro') }</p>
        </div>
        <div class="col-12 col-md-6">
            <figure>
                <a href="#network-layout"><img src="./images/network.png" alt="{ $_('map-alt') }" class=""></a>
            </figure>
            <h3><a href="#network-layout">{ $_('network-title') }</a></h3>
            <p>{ $_('network-intro') }</p>
        </div>
    </div> 

    <Row id="map-layout" class="line">
        <Col>
            <hr>
            <h2>{ $_('map-title-2') }</h2>
            { $_('map-text') }
        </Col>
    </Row>
    <Row>
        <Col>
            <div class="tabbable" id="map-tabs">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="{ sort == 'pat' ? 'active':''}" id="patents-tab" ><a href="#map-tabs" on:click="{ () => { sort = 'pat', selectedField = 0, selectedCity={id:0}, selectedCountry = ""; }}">{ $_('coinventions') }</a></li>
                    <li class="{ sort == 'pub' ? 'active':''}" id="publications-tab"><a href="#map-tabs" on:click="{ () => { sort = 'pub', selectedField = 0, selectedCity={id:0}, selectedCountry = ""; }}">{ $_('copublications') }</a></li>
                </ul>
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active">
                        <div class="row justify-content-md-left buttons">
                            <Col xs="12" sm="6" md="auto">
                                {#if (sort == 'pat') }
                                    <form>
                                        <select class="select-css" bind:value= {selectedField} > 
                                            {#each patArray as pat}
                                                <option value="{pat.id}" >
                                                    {pat.name}
                                                </option>
                                            {/each}
                                        </select> 
                                    </form>
                                {/if}
                                {#if (sort == 'pub')}
                                    <form>
                                        <select class="select-css" bind:value= {selectedField} > 
                                            {#each pubArray as pub}
                                                <option value="{pub.id}" >
                                                    {pub.name}
                                                </option>
                                            {/each}
                                        </select> 
                                    </form>
                                {/if}
                            </Col>
                            <Col xs="12" sm="6" md="auto">
                                <div class="periods">
                                    {#each years as year, i}
                                        <label class="form-check-label">
                                            <input type=radio bind:group={yearValue} value={year} > {(language == 'ar')?yearsAr[i]: years[i]}
                                        </label>
                                    {/each}
                                </div>
                            </Col>
                            {#if (selectedCountry == "")}
                            <Col md=auto>
                                <AutoComplete 
                                    items={cities.filter((city) => { return city.istop <= percentValue } )} 
                                    labelFunction= {(city) => cityTranslationFromId(city.id, hotspotArray) }                                 
                                    bind:selectedItem={selectedCity}
                                    showClear={false}
                                    hideArrow={true}
                                    placeholder={ $_('type-location') }
                                />
                            </Col>
                            {/if}
                            <Col md="auto">
                                <div class:hide={selectedCountry == ""}>
                                    <Dropdown {isOpen} toggle={() => (isOpen = !isOpen)}>
                                        <DropdownToggle caret>{  $_('hightlight-location')  + countryTranslationFromId(selectedCountry, countryArray)}{#if (language == 'zh')}{ $_('hightlight-location2')}{/if}</DropdownToggle>
                                        <DropdownMenu>
                                            {#each countryCitiesArray.filter((city) => { return city.istop <= percentValue } ) as city}
                                                <DropdownItem on:click={ () => {selectedCity = city; selectedCountry = "" }}>{cityTranslationFromId(city.id, hotspotArray)}</DropdownItem>
                                            {/each}
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>
                            </Col>
                        </div>
                        <Row class="titlesBlock" style="width:{w}'px'">
                            <Col xs="auto">
                                {$_('show-top') }  
                                {#each percents as percent}
                                <label class="form-check-label">
                                        <input type=radio bind:group={percentValue} value={percent} > {percent}%
                                    </label>
                                {/each}
                            </Col>
                            {#if (selectedCountry != 0 )}
                            <Col xs="auto">
                                <div class="selected-filter">{countryTranslationFromId(selectedCountry, countryArray)}
                                    <button on:click={ ()=> {selectedCountry = ""} } type="button" class="close" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </Col>
                            {/if}
                            {#if (selectedCity.id !=0 )}
                            {#if (!noFlowsSelectedCity )}
                            <Col xs="auto">
                                <div class="selected-filter">{ cityTranslationFromId(selectedCity.id, hotspotArray) }
                                    <button on:click={ ()=> {
                                            selectedCity = {id:0}; 
                                            } 
                                        }
                                        type="button" 
                                        class="close" 
                                        aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button> 
                                </div>
                            </Col>
                            {:else}
                            <div class="selected-filter" role="alert">
                                { $_('message-1-a') } <strong>{cityTranslationFromId(selectedCity.id, hotspotArray)}</strong> { $_('message-1-b') }
                                <button on:click={ ()=> {
                                    selectedCity = {id:0}; 
                                    } 
                                }
                                type="button" 
                                class="close" 
                                aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button> 
                            </div>
                            {/if}
                            {/if}
                        </Row>
                        <Row>
                            <Col class="chartContainer">
                                <div class="map" bind:clientWidth={w}>
                                <svg bind=zoomMap width="{w}" height="{Math.round(height)}"> 
                                    <g class="backgroundMap">
                                        <path d={bordersData} class="border" />
                                    </g>
                                    <g class="flows" >
                                    {#each flows as flow}
                                        <path 
                                            d= "{arclinks(projection(flow._fromCoords),(projection(flow._toCoords)))}" 
                                            style="display:{displayFlow(flow,percentValue, selectedCountry, selectedCity.id)}; stroke-width: {1/transform.k}"/>
                                    {/each}
                                    </g>
                                    <g class="nodes">
                                    {#each cities as city}    
                                        <!-- svelte-ignore missing-declaration -->
                                        <circle 
                                            class:highlightedHotspot = { city.id == selectedCity.id }
                                            cx= "{projection([city.Lng,city.Lat])[0]}"
                                            cy= "{projection([city.Lng,city.Lat])[1]}"
                                            r= "{ 3/transform.k }"
                                            fill = "{countryColors[city.ctry_label]}"
                                            on:click={ () => {selectedCountry = "", selectedCity = city, noFlowsSelectedCity=false }}
                                            style= "display: {displayCity(city.id, flows, selectedCity, selectedCountry, percentValue)}; stroke-width: { 1/transform.k }"
                                            on:mouseover={() => { mouseCity = city; mouseSort = sort}}
                                            on:mousemove={handleMousemove}
                                            on:mouseout={() => mouseCity = {'id':0}}
                                        />
                                    {/each}
                                    </g>
                                </svg>
                                </div>
                                <div class="btn-group-vertical zoomButtons">
                                    <button type="button" class="btn btn-secondary btn-sm zoom-in" aria-label="Zoom in" on:click={zoomIn}>
                                        <span aria-hidden="true">+</span>
                                    </button>
                                    <button type="button" class="btn btn-secondary btn-sm zoom-out" aria-label="Zoom out" on:click={zoomOut}>
                                        <span aria-hidden="true">-</span>
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <div class="col-md-3 legend">
                            <svg width = "{w}" height = "{(w < 400)?220:100}" class="legendSvg">
                                    {#each countryDetails as country, i}
                                        <g transform="translate({legendItemPosition(w,i)})" on:click={ () => {selectedCountry = country.id, selectedCity = {id:0}} } class="legendItem {(country.id == selectedCountry)?'active':'' }">
                                            <circle cx="{(dir == 'rtl')? legendItemWidth: 6}" cy="-6" r="6" fill={countryColors[country.name]} />
                                            <text x="{(dir == 'rtl')? legendItemWidth - 20 : 20}">{countryTranslationFromId(country.id, countryArray)}</text>
                                        </g>
                                    {/each}
                                </svg>            
                            </div>
                        </Row>
                    </div>
                </div>
            </div>
        </Col>
    </Row>
    <Row id="network-layout">
        <Col>
            <hr>
            <h2>{ $_('network-title-2') }</h2>
            { $_('network-text') }
        </Col>
    </Row>
    <Row>
        <Col>
            <div class="tabbable" id="network-tabs">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="{ sort1 == 'pat' ? 'active':''}" id="patents-tab" ><a href="#network-tabs" on:click="{ () => { sort1 = 'pat', selectedField1 = 0, selectedCity1={id:0}, selectedCountry1 = ""; }}">{ $_('coinventions') }</a></li>
                    <li class="{ sort1 == 'pub' ? 'active':''}" id="publications-tab"><a href="#network-tabs" on:click="{ () => { sort1 = 'pub'; selectedField1 = 0, selectedCity1={id:0}, selectedCountry1 = ""; }}">{ $_('copublications') }</a></li>
                </ul>
                <div class="tab-content">
                    <div role="tabpanel" class="tab-pane active" >
                        <div class="row justify-content-md-left buttons">
                            <Col xs="12" sm="6" md="auto" >
                                <form>
                                    <select class="select-css dropdown-toggle" bind:value= {selectedField1} > 
                                        {#if (sort1 == 'pat') }
                                            {#each patArray as pat}
                                                <option value="{pat.id}">
                                                    {pat.name}
                                                </option>
                                            {/each}
                                        {/if}
                                        {#if (sort1 == 'pub') }
                                            {#each pubArray as pub}
                                                <option value="{pub.id}">
                                                    {pub.name}
                                                </option>
                                            {/each}
                                        {/if}
                                    </select> 
                                </form>
                            </Col>
                            <Col xs="12" sm="6" md="auto">
                                <div class="periods">
                                    {#each years as year, i}
                                        <label class="form-check-label">
                                            <input type=radio bind:group={yearValue1} value={year}> {(language == 'ar')?yearsAr[i]: years[i]}
                                        </label>
                                   {/each}
                                </div>
                            </Col>
                            {#if (selectedCountry1 == "")}
                            <Col md=auto>
                                <AutoComplete 
                                    items={cities1.filter((city) => { return city.istop <= percentValue1 } )} 
                                    labelFunction={(city) => cityTranslationFromId(city.id, hotspotArray) }                                 
                                    bind:selectedItem={selectedCity1}
                                    showClear={false}
                                    hideArrow={true}
                                    placeholder={ $_('type-location') }
                                />
                            </Col>
                            {/if}
                            {#if (selectedCountry1 != "")}
                            <Col md="auto">
                                <Dropdown {isOpen} toggle={() => (isOpen = !isOpen)}>
                                <DropdownToggle caret>{  $_('hightlight-location') + countryTranslationFromId(selectedCountry1, countryArray)}</DropdownToggle>
                                <DropdownMenu>
                                    {#each countryCitiesArray1.filter((city) => { return city.istop <= percentValue1 } ) as city}
                                        <DropdownItem on:click={ () => {
                                            selectedCity1 = city; 
                                            selectedCountry1 = ""; 
                                            updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id, false);}}>{cityTranslationFromId(city.id, hotspotArray)}</DropdownItem>
                                    {/each}
                                </DropdownMenu>
                            </Dropdown>
                            </Col>
                            {/if}
                        </div>
                        <Row>
                            <Col>
 
                                <Row>
                                    <Col md="9">
                                        <Row class="titlesBlock" style="width:{netWidth}'px'">
                                            <Col xs="auto" class="top-n">{$_('show-top') }   
                                                {#each percents as percent}
                                                <label class="form-check-label">
                                                        <input type=radio bind:group={percentValue1} value={percent} on:change="{ () => updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id,false) }"> {percent}%
                                                    </label>
                                                {/each}
                                            </Col>
                                            {#if (selectedCountry1 != "" )}
                                            <Col xs="auto">
                                                <div class="selected-filter">{ countryTranslationFromId(selectedCountry1, countryArray)} 
                                                    <button on:click={ ()=> {selectedCountry1 = ""; 
                                                        updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id, false);
                                                        }} type="button" class="close" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                            </Col>
                                            {/if}
                                            {#if (selectedCity1.id !=0 )}
                                                {#if (!noFlowsSelectedCity1)}
                                                <Col xs="auto">
                                                    <div class="selected-filter">{ cityTranslationFromId(selectedCity1.id, hotspotArray) }
                                                        <button on:click={ ()=> {
                                                            selectedCity1 = {id:0}; 
                                                            updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id, false);}} 
                                                            type="button" class="close" aria-label="Close">
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                </Col>
                                                {:else}
                                                <div class="selected-filter" role="alert">
                                                    { $_('message-1-a') } <strong>{cityTranslationFromId(selectedCity1.id, hotspotArray)}</strong> { $_('message-1-b') }
                                                    <button on:click={ ()=> {
                                                        selectedCity1 = {id:0}; 
                                                        updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id, false);
                                                        } 
                                                    }
                                                    type="button" 
                                                    class="close" 
                                                    aria-label="Close">
                                                    <span aria-hidden="true">&times;</span>
                                                </button> 
                                                </div>
                                                {/if}
                                            {/if}
                                        </Row>
                                        <div class="network"  bind:clientWidth ={netWidth} >
                                        <svg width="{netWidth}" height="{Math.round(netHeight)}"> 
                                            <g class="flows" >
                                            {#each flows1 as flow  }
                                                <line 
                                                    x1 = "{flow.source.x }"
                                                    y1 = "{flow.source.y }"
                                                    x2 = "{flow.target.x }"
                                                    y2 = "{flow.target.y }"
                                                    id = "{'link_'+flow.from+'-'+flow.to}"
                                                    class = "{flow._visible?'showFlow':'hide'}"
                                                    style = "stroke-width:{1/transformNet.k}"
                                                />
                                            {/each}
                                            </g>
                                            <!---->
                                            <g class="nodes">
                                            {#each cities1 as city}    
                                                <circle 
                                                    cx= "{city.x }"
                                                    cy= "{city.y }"
                                                    r= "{ sqrtScale(Number(city[sort1+"Q"]))/transformNet.k }"
                                                    fill = "{countryColors[city.ctry_label]}"
                                                    style= "stroke-width: { 1/transformNet.k }; "
                                                    id = "{'node_'+city.id}"
                                                    on:click={ () => {
                                                        selectedCountry1 = "", selectedCity1 = city;
                                                        updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id, false);
                                                    }}
                                                    class:hide = {!city._visible}
                                                    class:highlightedHotspot = { city.id == selectedCity1.id }
                                                    on:mousemove={handleMousemove}
                                                    on:mouseover={() => { mouseCity = city; mouseSort = sort1}}
                                                    on:mouseout={() => mouseCity = {'id':0}}
                                                />
                                            {/each}
                                            </g>
                                        </svg>
                                        </div>
                                        <div class="btn-group-vertical zoomButtons">
                                            <button type="button" class="btn btn-secondary btn-sm zoom-in" aria-label="Zoom in" on:click={zoomInNet}>
                                                <span aria-hidden="true">+</span>
                                            </button>
                                            <button type="button" class="btn btn-secondary btn-sm zoom-out" aria-label="Zoom out" on:click={zoomOutNet}>
                                                <span aria-hidden="true">-</span>
                                            </button>
                                        </div>
                                    </Col>
                                    <div class="col-md-3 legend" bind:clientWidth ={legendWidth1}>
                                        <svg width = "{legendWidth1}" height = "{(legendWidth1 < 400)?220:100}" class="legendSvg">
                                            {#each countryDetails as country, i}
                                                <g  transform="translate({ legendItemPosition(legendWidth1,i)})" 
                                                    on:click={ () => {selectedCountry1 = country.id, selectedCity1 = {id:0}; updateNetFlowsNodes(percentValue1, selectedCountry1, selectedCity1.id,false);} } 
                                                    class="legendItem {(country.id == selectedCountry1)?'active':'' }">
                                                    <circle cx="{(dir == 'rtl')?  0 : 6}" cy="-6" r="6" fill={country.color} ></circle>
                                                    <text x="{(dir == 'rtl')? - 20 : 20}">{countryTranslationFromId(country.id, countryArray)}</text>
                                                </g>
                                            {/each}
                                        </svg>            
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </Col>
    </Row>
    <div class="row">
		<div class="col note"> 
			{ $_('note-a') } <a href="https://www.wipo.int/wipr/{language}/2019/">{ $_('note-b') }</a>.
		</div>
	</div>
</div>
<!--/Container-->

<div class="arrow_box" bind:clientWidth="{tooltipWidth}" style='display:{(mouseCity.id > 0 && !draggingCircle)?"block":"none"}; 
                                left: { xPositionTooltip(mousePosition)}px;
                                top:{ (mousePosition.y - 45) }px;
                                position:absolute; '
                                >
    <div class="title">{cityTranslationFromId(mouseCity.id, hotspotArray)}</div>
    {#if (language == 'zh') }
        <div>{mouseSort == 'pat'?$_('patents'):$_('publications')}{ $_('tooltip-text') }: <span class="value">{ $number(Math.round(mouseCity[mouseSort+"Q"]))}</span>  </div>
        <div>{mouseSort == 'pat'?$_('copatents'):$_('copublications')}{ $_('tooltip-text') }: <span class="value">{$number(Math.round(mouseCity["co"+mouseSort+"Q"]))}</span>  </div>
    {:else if (language == 'ru')}
        <div>{ $_('tooltip-text') } {mouseSort == 'pat'?$_('patents'):$_('publications')}: <span class="value">{ $number(Math.round(mouseCity[mouseSort+"Q"]))}</span></div>
        <div>{mouseSort == 'pat'?$_('tooltip-text-copatents'):$_('tooltip-text-copublications')}: <span class="value">{$number(Math.round(mouseCity["co"+mouseSort+"Q"]))}</span></div>
    {:else}
        <div>{ $_('tooltip-text') } {mouseSort == 'pat'?$_('patents'):$_('publications')}: <span class="value">{ $number(Math.round(mouseCity[mouseSort+"Q"]))}</span></div>
        <div>{ $_('tooltip-text') } {mouseSort == 'pat'?$_('copatents').toLocaleLowerCase():$_('copublications').toLocaleLowerCase()}: <span class="value">{$number(Math.round(mouseCity["co"+mouseSort+"Q"]))}</span></div>
    {/if}
</div>
{/if}
